module.exports = __webpack_public_path__ + "images/doc-shimo-list-10d0bf58acdb0f640051c51c1c51dc29.png";